export default {
  enforceUIDGIDText: 'Changing a user\'s UID or GID may result in files and/or processes '
    + 'left on one or more servers without an associated user account. '
    + 'You may need to manually reset the ownership of these files to re-associate '
    + 'them with the correct user account, or you may enforce consistency with this '
    + 'setting. This setting cannot be disabled once saved.',

  multifactorText: 'When TOTP MFA is enabled on a system, users who have set up TOTP are prompted for a TOTP'
  + ' token when they log in to the system.',

  publicKeyAuthText: `When Public Key Authentication is selected in conjunction with SSH Password Login, users will be
  able to authenticate using either of the selected options. When just Public Key Authentication is
  selected, the user will be forced to have a properly configured public key to authenticate.`,

  sshLoginText: `When SSH Password Login is selected in conjunction with Public Key Authentication, users
  will be able to authenticate using either of the selected options. When just SSH Password
  Login is selected, the user will be forced to enter a valid password to authenticate.`,

  systemInsightsText: 'When checked, JumpCloud will capture additional information from the system for enhanced reporting.',

  spMetadataText: 'Uploading a metadata XML file provided by your Service Provider will result in the connector attributes being pre-populated with the contents of the metadata file. Uploading additional files will overwrite any attribute values provided by the previous file.',
};
